export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/info-gray-icon.42d460ee.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};